import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from "react";
// Create a context with a default undefined value
var GlobalSelectedBranchContext = /*#__PURE__*/ createContext(undefined);
// This is your provider component
export var GlobalSelectedBranchProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(3), 2), selectedBranchId = _useState[0], setSelectedBranchId = _useState[1];
    var contextValue = {
        selectedBranchId: selectedBranchId,
        setSelectedBranchId: setSelectedBranchId
    };
    return /*#__PURE__*/ _jsx(GlobalSelectedBranchContext.Provider, {
        value: contextValue,
        children: children
    });
};
export var useGlobalSelectedBranchContext = function() {
    var context = useContext(GlobalSelectedBranchContext);
    if (!context) {
        throw new Error("useGlobalSelectedBranchContext must be used within a GlobalSelectedBranchProvider");
    }
    return context;
};
